/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from 'react'
import Dropdown from '../../../components/Dropdown'
import InputBox from '../../../components/InputBox'
import { useRef,useState } from 'react'
import CustomDatePicker from '../../../components/DatePicker'
import dayjs from 'dayjs'
import OrganizationDropdownCorpWithSearch from '../../ManageAdminAndCoporateUser/Dropdowns/dropdownWithSearchForOrg'
import DropdownWithSearchForSubDiv from '../../ManageAdminAndCoporateUser/Dropdowns/dropdownWithSearchforSubDiv'

export default function FilterBtn({dateError,setdateError,isFilterOpen,setIsFilterOpen,handleApplyFilter,isFilterOrganization,initialState,filterValues,setFilterValues,handleOpenFilter,selectedOrganizationName,setSelectedOrganizationName,setSubDivisionDataLoading,subDivisionDataLoading,userArr,isPatientSearch}) {
    const [isOpen,setIsOpen] = useState(false)
    const [isSubdivOpen,setIsSubdivOpen] = useState(false)
    const redioButtonStatus = ["active", "inactive"]

    function handleSelectDate(id,date,dateString,termkey){
        if(id==="filter_start_date"){
            setFilterValues((prv) => ({
                ...prv,
                start_date: dateString,
            }));
        }
        else{
            setFilterValues((prv) => ({
                ...prv,
                end_date: dateString,
            }));
        }
        
    }

    function transformStatus(item) {
        // Add your transformation logic here
        if (item === 'active') {
            return 'Active';
        } else if (item === 'inactive') {
            return 'Inactive';
        }
        // Add more transformations if needed
    
        // If no transformation is needed, return the original item
        return item;
    }

    const handleCheckboxChange = (status) => {
        // Check if the status is already in the array
        const index = filterValues?.status?.indexOf(status);
        if(filterValues.status===undefined){
            setFilterValues((prevFilter) => ({
                ...prevFilter,
                status: [status],
            }));
            return
        }
        if (index === -1) {
            // If the status is not in the array, add it
            setFilterValues((prevFilter) => ({
                ...prevFilter,
                status: [...prevFilter?.status, status],
            }));
        } else {
            // If the status is already in the array, remove it
            setFilterValues((prevFilter) => ({
                ...prevFilter,
                status: prevFilter?.status?.filter((s) => s !== status),
            }));
        }
    };

    const handleCheck=()=>{
        if((dayjs(filterValues?.end_date).isBefore(dayjs(filterValues?.start_date)))&&(filterValues?.end_date!==undefined&&filterValues.start_date!==undefined)){
            return true
        }
        return false
    }
    function handleOnChangeInput(id,option){
        const fieldToUpdate = {
            column_field:"column_field",
            action_performed:"action_performed",
           
        }[id];
        if(fieldToUpdate){
            setFilterValues((prev)=>({
                ...prev,
                [fieldToUpdate]:option
            }))
        }
    }
    return (
        <div className='xl:relative ml-2.5 2xl:mb-0 mb-2.5'>
            <button id='filter' type='button' className='flex items-center border border-[#972E4C] rounded-[15px] px-4 py-2 min-w-max' onClick={handleOpenFilter}>
                <img src="/images/filter_icon.svg" alt="icon" />
                <span className='text-lg font-semibold text-[#972E4C] ml-2.5'>Filter</span>
            </button>
            {
                isFilterOpen && 
               
                    <div  className=' absolute top-[112px] xl:top-14 filter_top right-0 xl:left-[-544px] left-auto bg-white rounded-[15px] border border-[#D296B2] px-2.5 pt-4 py-[26px] shadow-s2 w-[653px] z-[99]'>
                        <div className='flex justify-between items-center mb-4'>
                            <p className='text-sm font-semibold text-[#52555D]'>Filter by:</p>
                            {dateError &&<p className="text-xs text-red-500 mt-2 mr-8">Please select the valid date range.</p>}
                            <button type='button' onClick={()=>{setIsFilterOpen(!isFilterOpen),setdateError(false)}}>
                                <img src="/images/cross_mark_gray.svg" alt="icon" />
                            </button>
                        </div>
                        <div className='flex flex-wrap -mx-2'>
                            <div className='w-1/2 px-2 mb-4'>
                                <div className='w-full'>
                                    <CustomDatePicker 
                                        id={"filter_start_date"}
                                        classKey={'border border-[#C5C9DA]  rounded-lg px-3.5 py-[11px] text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center'}
                                        format="MMM DD, YYYY"
                                        state={filterValues}
                                        placeholder={"Select start date"}
                                        label={"Start Date"} 
                                        termkey={filterValues?.start_date}
                                        handleSelect={handleSelectDate}
                                        imageClass={true}
                                        setdateError={setdateError}
                                    />
                                </div>
                            </div>
                            <div className='w-1/2 px-2 mb-4'>
                                <div className='w-full'>
                                    <CustomDatePicker 
                                        label={"End Date"} 
                                        classKey={'border border-[#C5C9DA]  rounded-lg px-3.5 py-[11px] text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center'}
                                        placeholder={"Select end date"}
                                        format="MMM DD, YYYY"
                                        state={filterValues}
                                        termkey={filterValues?.end_date}
                                        handleSelect={handleSelectDate}
                                        id={"filter_end_date"}
                                        setdateError={setdateError}
                                    />
                                </div>
                            </div>
                
                            <div className={`${isPatientSearch===undefined?'w-1/2':'w-full'} px-2 mb-4`}>
                                <div className="w-full">
                                    <OrganizationDropdownCorpWithSearch
                                        label={"Organization Name"}
                                        id={`organization_name`}
                                        placeholder={'Select organization name'}
                                        disabled={false}
                                        setSubDivisionDataLoading={setSubDivisionDataLoading}
                                        selectedOrganizationName={selectedOrganizationName}
                                        setSelectedOrganizationName={setSelectedOrganizationName}
                                        selectOrgName={selectedOrganizationName[0]?.organization_name}
                                        setFilterValues={setFilterValues}
                                        index={0}
                                        isOpen={isOpen}
                                        setIsSubdivOpen={setIsSubdivOpen}
                                        setisOpen={setIsOpen}
                                        adminCorpLink={true}
                                        optionId={"option_organization_name"}
                                        isObserver={true}
                                    />
                                </div>
                            </div>
                            {isPatientSearch===undefined&&<div className='w-1/2 px-2 mb-4'>
                                <div className="w-full">
                                    <DropdownWithSearchForSubDiv
                                        label={"Sub Division Name"}
                                        id={`sub_divisions`}
                                        index={0}
                                        orgId={selectedOrganizationName[0]}
                                        isBlack={(userArr[0]===undefined||userArr[0]?.length===0)}
                                        placeholder={((userArr[0]===undefined)||userArr[0]?.length===0)?'Select sub division names':`${userArr[0]?.filter((item)=>item.isChecked===true)?.length} Selected`}
                                        disabled={selectedOrganizationName[0].organization_name === '' || selectedOrganizationName[0].organization_name === undefined ? true : false}
                                        selectedOrganizationName={selectedOrganizationName}
                                        subDivisionDataLoading={subDivisionDataLoading}
                                        setFilterValues={setFilterValues}
                                        isOpen={isSubdivOpen}
                                        setisOpen={setIsSubdivOpen}
                                        
                                    />
                                </div>
                            </div>}
                            {isPatientSearch===undefined&&<div className='w-full px-2.5 mb-[35px]'>
                                <p className='text-xs font-semibold text-[#000000] pb-1.5'>Status</p>
                                <div className='flex items-center'>
                                    {redioButtonStatus.map((item) =>
                                        (<div className="p-2" key={item}>
                                            <div className="relative checkbox custom-checkBoxBlue1 provider-tbody device-status">
                                                <input 
                                                    id={item}
                                                    data_testid={"status"} 
                                                    type="checkbox" 
                                                    name="default-checkbox" 
                                                    checked={(filterValues?.status) && filterValues?.status.includes(item)} 
                                                    onChange={() => handleCheckboxChange(item)} 
                                                />
                                                <label htmlFor={item} className="text-base font-normal text-[#000] pl-5 w-full cursor-pointer">
                                                    {transformStatus(item)}
                                                </label>
                                            </div>
                                        </div>))}
                                </div>
                            </div>}
                        </div>
                        <div className="flex mt-[13px] justify-between">
                            <button  onClick={()=>{handleApplyFilter(false),setdateError(false),setFilterValues(initialState),setIsFilterOpen(false)}}
                                id="Cancel"
                                className="py-2.5 px-4 rounded-[16px] border border-[#972E4C] text-lg font-semibold text-[#972E4C] mr-[38px]" 
                            >Clear All</button>
                            <button  
                                onClick={()=>{
                                    if(handleCheck())
                                    {setdateError(true) 
                                        return}
                                    handleApplyFilter(true),setIsFilterOpen(false)}}
                                type='button'
                                id="apply-filter"
                                disabled={Object.values(filterValues).every(value => typeof value === 'string' && value.trim() === '')} 
                                className={`py-2.5 w-[106px] px-4 rounded-[16px]  ${Object.values(filterValues).every(value => typeof value === 'string' && value.trim() === ''||value===undefined)?'bg-[#777C88]':'bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] border border-[#972E4C]'}   text-lg font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf`}>
                                Apply
                            </button>
                        </div>
                    </div>
                // </motion.div>
            }
        </div>  
    )
}
